jQuery(document).ready(function ($) {
  var map;
  var polygons = [];
  var markersArray = [];
  var markers = [];
  var internectMarkersArray = [];
  var internectSearchTags = [];
  var layers = [];
  var coverageArray = [];
  var cta_link = "";
  var map_page = $("#map_page").data("url");
  var form_url = $("#form_page").data("url");
  var static_provider = $("#static_provider").data("id");
  var package_url = $("#package_page").data("url");
  var marker_icon = $("#marker_icon").data("icon");
  var marker_active_icon = $("#marker_icon").data("icon");
  var no_coverage_button = $("#no_coverage_button").data("button");
  var provider_button = $("#provider_button").data("button");
  var coverage_message = $("#coverage_message").html();
  var no_coverage_message = $("#no_coverage_message").html();
  var planned_coverage_button = $("#planned_coverage_button").data("button");
  var planned_coverage_message = $("#planned_coverage_message").html();
  var openserve_id = $(".openserve").data("id");
  var frogfoot_id = $(".frogfoot").data("id");
  var strokeColor = $("#map_overlay_styles").data("strokecolor");
  var fillColor = $("#map_overlay_styles").data("fillcolor");
  var strokeOpacity = $("#map_overlay_styles").data("strokeopacity");
  var strokeWeight = $("#map_overlay_styles").data("strokeweight");
  var fillOpacity = $("#map_overlay_styles").data("fillopacity");

  // coverageArray.push('09090999');

  /*
    $('.static-privider').each( function() {
      var $this = $(this);
      var id = $this.data( 'id' );
      static_provider.push(id);
    }
  */

  if ($("#faircom_coverage_map").length > 0) {
    initMap();
  }

  marker_icon = {
    url: marker_icon, // url
    scaledSize: new google.maps.Size(30, 42.95),
  };

  function unique(list) {
    var result = [];
    $.each(list, function (i, e) {
      if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
  }

  var infowindow = null;

  function drawMarkers() {
    var marker_icon_drawMarkers = {
      url: marker_icon, // url
      scaledSize: new google.maps.Size(30, 42.95),
    };

    $(".map-marker").each(function () {
      var $this = $(this);
      var title = $this.data("title");
      var address = $this.data("address");
      var building = $this.data("building");
      var id = $this.data("id");
      var lat = $this.data("lat");
      var lng = $this.data("lng");
      var geocoder = new google.maps.Geocoder();
      var latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

      var latlngStr = parseFloat(lat) + "," + parseFloat(lng);

      //var title_prestine = title.replace(/'/g, '');

      internectMarkersArray.push(latlngStr);

      internectSearchTags.push({
        label: title.replace(/'/g, ""),
        value: address,
        geocode: latlngStr,
        building: building,
        provider_id: id,
      });

      /*
            geocoder.geocode({'location': latlng}, function(results, status) {
              if (status === 'OK') {
                if (results[0]) {
                  internectMarkersArray.push(results[0].place_id);
                  internectSearchTags.push({
                    label: title,
                    value: address,
                    geocode: results[0]
                  });
                  console.log('Geocode successful: ' + address + ' ' + status);
                  console.log(results[0]);
                }
              }
              else{
                console.log('Cannot geocode: ' + address + ' ' + status);
              }
            });
          */

      var contentString =
        '<div class="infowindow" style="text-align:center;">' +
        "<h5>" +
        title +
        "</h5>" +
        "</div>";

      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: map,
        icon: marker_icon_drawMarkers,
      });
      markers.push(marker);

      coverageArray = [];
      coverageArray.push(id);

      var uniqueProviders = unique(coverageArray);

      marker.addListener("click", function () {
        console.log('test');
        if (infowindow) {
          infowindow.close();
        }
        infowindow = new google.maps.InfoWindow({
          maxWidth: 320,
        });

        infowindow.setContent(contentString);
        infowindow.open(map, marker);

        map.setCenter({ lat: lat, lng: lng });

        $("#map-location-input").val(title);
        var location_string = lat + "," + lng;
        fetch_providers(uniqueProviders, location_string, building);
      });
    });
  }

  function addLayers() {
    //var myParser = new geoXML3.parser({map: map, suppressInfoWindows:true});
    //var myParser = new geoXML3.parser({map: map});
    //var kml = $('.provider-data').data('kml');
    $(".provider-data").each(function () {
      var layer = new google.maps.Data();
      layer.addListener("addfeature", createPolygons);
      var kml = $(this).data("kml");
      var name = $(this).data("name");
      var id = $(this).data("id");
      if (kml) {
        $.ajax(kml).done(function (xml) {
          var jsonData = toGeoJSON.kml(xml);
          //console.log(jsonData);
          for (var i = 0; i < jsonData.features.length; i++) {
            jsonData.features[i].properties.name = name;
            jsonData.features[i].properties.id = id;
          }
          layer.addGeoJson(jsonData);
        });
        layers.push(layer);
      }
    });

    var FTTHQuery = "//openserve.co.za/gis/apps/api/ucmTechOSFibre?";
    var ftth_array = [];

    //Define custom WMS layer
    var FTTHLayer = new google.maps.ImageMapType({
      getTileUrl: function (coord, zoom) {
        var proj = map.getProjection();
        var zfactor = Math.pow(2, zoom);
        // get Long Lat coordinates
        var top = proj.fromPointToLatLng(
          new google.maps.Point(
            (coord.x * 256) / zfactor,
            (coord.y * 256) / zfactor
          )
        );
        var bot = proj.fromPointToLatLng(
          new google.maps.Point(
            ((coord.x + 1) * 256) / zfactor,
            ((coord.y + 1) * 256) / zfactor
          )
        );

        var deltaX = 0;
        var deltaY = 0;
        //create the Bounding box string
        var bbox =
          top.lng() +
          deltaX +
          "," +
          (bot.lat() + deltaY) +
          "," +
          (bot.lng() + deltaX) +
          "," +
          (top.lat() + deltaY);

        //FTTH WMS URL
        var url =
          "//openserve.co.za/gis/arcgis/services/isp/FTTH_SRID4148/MapServer/WMSServer?";
        url += "&REQUEST=GetMap"; //WMS operation
        url += "&SERVICE=WMS"; //WMS service
        url += "&VERSION=1.1.1"; //WMS version
        url += "&LAYERS=0,1"; //WMS layers
        url += "&Styles=OSPlanned-D07114,OSWorking-B41F58"; //Style for Each Layer, Choose from list below
        // url += "&Styles=OSWorking-B41F58";  //Style for Each Layer, Choose from list below
        url += "&FORMAT=image/png24"; //WMS format
        url += "&BGCOLOR=0xFFFFFF";
        //url += "&ANTIALIASING=ON";
        //url += "&DPI=300";
        url += "&TRANSPARENT=TRUE";
        //url += "&visible=false";
        url += "&SRS=EPSG:4148"; //set WGS84
        url += "&BBOX=" + bbox; // set bounding box
        url += "&WIDTH=256"; //tile size in google
        url += "&HEIGHT=256";
        //url += "&SLD_BODY=%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0D%0A%3Csld%3AStyledLayerDescriptor%20version%3D%221.0.0%22%20xmlns%3D%22http%3A%2F%2Fwww.opengis.net%2Fogc%22%20xmlns%3Asld%3D%22http%3A%2F%2Fwww.opengis.net%2Fsld%22%20xmlns%3Aogc%3D%22http%3A%2F%2Fwww.opengis.net%2Fogc%22%20xmlns%3Agml%3D%22http%3A%2F%2Fwww.opengis.net%2Fgml%22%20xmlns%3Axsi%3D%22http%3A%2F%2Fwww.w3.org%2F2001%2FXMLSchema-instance%22%20xsi%3AschemaLocation%3D%22http%3A%2F%2Fwww.opengis.net%2Fsld%20http%3A%2F%2Fschemas.opengis.net%2Fsld%2F1.0.0%2FStyledLayerDescriptor.xsd%22%3E%0D%0A%09%3Csld%3ANamedLayer%3E%0D%0A%09%09%3C%21--%20layer%20%221%22%20is%20the%20%22Working%22%20FTTH%20polygon%20layer%20in%20the%20WMS%20service%20--%3E%09%0D%0A%09%09%3Csld%3AName%3E1%3C%2Fsld%3AName%3E%0D%0A%09%09%3Csld%3AUserStyle%3E%0D%0A%09%09%09%3Csld%3AName%3EOSWorking%3C%2Fsld%3AName%3E%0D%0A%09%09%09%3Csld%3ATitle%3EOSWorking%3C%2Fsld%3ATitle%3E%0D%0A%09%09%09%3Csld%3AFeatureTypeStyle%3E%0D%0A%09%09%09%09%3Csld%3ARule%3E%09%09%09%09%09%09%0D%0A%09%09%09%09%09%3Csld%3APolygonSymbolizer%3E%0D%0A%09%09%09%09%09%09%3Csld%3AFill%3E%0D%0A%09%09%09%09%09%09%09%3Csld%3ACssParameter%20name%3D%22fill%22%3E%23000050%3C%2Fsld%3ACssParameter%3E%0D%0A%09%09%09%09%09%09%09%3Csld%3ACssParameter%20name%3D%22fill-opacity%22%3E0.80%3C%2Fsld%3ACssParameter%3E%0D%0A%09%09%09%09%09%09%3C%2Fsld%3AFill%3E%09%09%09%09%09%09%0D%0A%09%09%09%09%09%3C%2Fsld%3APolygonSymbolizer%3E%0D%0A%09%09%09%09%3C%2Fsld%3ARule%3E%0D%0A%09%09%09%3C%2Fsld%3AFeatureTypeStyle%3E%0D%0A%09%09%3C%2Fsld%3AUserStyle%3E%0D%0A%09%3C%2Fsld%3ANamedLayer%3E%0D%0A%09%3Csld%3ANamedLayer%3E%0D%0A%09%09%3Csld%3AName%3E0%3C%2Fsld%3AName%3E%0D%0A%09%09%3Csld%3AUserStyle%3E%0D%0A%09%09%09%3Csld%3AName%3EOSPlanned%3C%2Fsld%3AName%3E%0D%0A%09%09%09%3Csld%3ATitle%3EOSPlanned%3C%2Fsld%3ATitle%3E%0D%0A%09%09%09%3Csld%3AFeatureTypeStyle%3E%0D%0A%09%09%09%09%3Csld%3ARule%3E%09%09%09%09%09%09%0D%0A%09%09%09%09%09%3Csld%3APolygonSymbolizer%3E%0D%0A%09%09%09%09%09%09%3Csld%3AFill%3E%0D%0A%09%09%09%09%09%09%09%3Csld%3ACssParameter%20name%3D%22fill%22%3E%23005000%3C%2Fsld%3ACssParameter%3E%0D%0A%09%09%09%09%09%09%09%3Csld%3ACssParameter%20name%3D%22fill-opacity%22%3E0.60%3C%2Fsld%3ACssParameter%3E%0D%0A%09%09%09%09%09%09%3C%2Fsld%3AFill%3E%0D%0A%09%09%09%09%09%09%0D%0A%09%09%09%09%09%3C%2Fsld%3APolygonSymbolizer%3E%0D%0A%09%09%09%09%3C%2Fsld%3ARule%3E%0D%0A%09%09%09%3C%2Fsld%3AFeatureTypeStyle%3E%0D%0A%09%09%3C%2Fsld%3AUserStyle%3E%0D%0A%09%3C%2Fsld%3ANamedLayer%3E%0D%0A%3C%2Fsld%3AStyledLayerDescriptor%3E";
        //url+= "&SLD=http://xxx"
        //console.log(url);
        //console.log(url);
        return url; // return URL for the tile
      },
      tileSize: new google.maps.Size(256, 256),
      isPng: true,
      opacity: 0.3,
    });

    if (openserve_id) {
      map.overlayMapTypes.push(FTTHLayer);
    }

    /*
    //Example Layer entry
    layer1 = new google.maps.Data();
    layer1.addListener('addfeature', createPolygons);
    // Load GeoJSONs.
    layer1.addGeoJson({
      "type": "FeatureCollection",
      "features": [{
        "type": "Feature",
        "properties": {
          "name": "Layer 1 name",
          "desc": "Layer 1 desc"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [18.465311470569,-33.92374980367263],
              [18.47027949724097,-33.9801885383824],
              [18.45270032219342,-34.03510416229421],
              [18.4913546821571,-34.06273144450208],
              [18.53412961154693,-33.98344874062358],
              [18.51657683949251,-33.92134269938818],
              [18.48940485274629,-33.89019703777676],
              [18.465311470569,-33.92374980367263],
            ]
          ]
        }
      }]
    });
    */
    //layers.push(layer1);

    /*
    $.post(ajax_object.ajaxurl,{
        security: $(document).find('#fibre_map_nonce_field').attr('value'),
        action: 'frogfoot_overlay_query'
      },
      function(data) {
        console.log(data);
      }
    );
    */
  }

  function initMap() {
    map = new google.maps.Map(document.getElementById("faircom_coverage_map"), {
      zoom: 12,
      center: { lat: -33.9434753, lng: 18.4541519 },
      //styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
      //styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"administrative.country","elementType":"geometry.fill","stylers":[{"visibility":"off"},{"color":"#fc6e6e"}]},{"featureType":"administrative.province","elementType":"geometry.fill","stylers":[{"visibility":"off"},{"hue":"#008aff"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#bee0ee"},{"visibility":"on"}]}]
      //styles: [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.country","elementType":"geometry","stylers":[{"lightness":"70"},{"weight":"1.70"},{"saturation":"-100"},{"visibility":"on"}]},{"featureType":"administrative.country","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"geometry","stylers":[{"visibility":"on"},{"weight":"0.79"},{"lightness":"59"}]},{"featureType":"administrative.province","elementType":"labels","stylers":[{"visibility":"simplified"},{"lightness":"53"}]},{"featureType":"administrative.locality","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.locality","elementType":"labels","stylers":[{"visibility":"simplified"},{"lightness":"52"},{"saturation":"-100"}]},{"featureType":"administrative.neighborhood","elementType":"geometry.fill","stylers":[{"saturation":"-100"},{"lightness":"66"},{"visibility":"off"}]},{"featureType":"administrative.neighborhood","elementType":"labels","stylers":[{"saturation":"-100"},{"visibility":"simplified"},{"lightness":"10"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"saturation":"-35"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"color":"#f0f0ec"},{"visibility":"on"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#fbfcf6"}]},{"featureType":"landscape.natural","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"visibility":"off"},{"saturation":"-9"},{"hue":"#ff0000"}]},{"featureType":"landscape.natural.landcover","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.terrain","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.terrain","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"off"},{"hue":"#ff0000"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":100},{"visibility":"on"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"},{"saturation":"-100"},{"color":"#cdcdcd"}]},{"featureType":"road","elementType":"labels.text","stylers":[{"visibility":"simplified"},{"hue":"#ff0000"},{"lightness":"15"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"visibility":"on"},{"lightness":700}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#ccecf2"}]}]
      styles: [
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [{ color: "#444444" }],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [{ color: "#f2f2f2" }],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "road",
          elementType: "all",
          stylers: [{ saturation: -100 }, { lightness: 45 }],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [{ visibility: "simplified" }],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "water",
          elementType: "all",
          stylers: [{ color: "#b6dae0" }, { visibility: "on" }],
        },
      ],
      //disableDefaultUI: true
      mapTypeControl: false,
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: false,
    });

    //LIMIT PANNING TO WESTERN CAPE
    var allowedBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(-34.646336, 17.685204),
      new google.maps.LatLng(-30.420738, 24.364625)
    );
    var lastValidCenter = map.getCenter();

    google.maps.event.addListener(map, "center_changed", function () {
      if (allowedBounds.contains(map.getCenter())) {
        // still within valid bounds, so save the last valid position
        lastValidCenter = map.getCenter();
        return;
      }
      // not valid anymore => return to last valid position
      map.panTo(lastValidCenter);
    });

    drawMarkers();
    addLayers();

    // move the marker to a new position, and center the map on it
    function update_map(latlngStr) {
      var marker_active_icon_active = {
        url: marker_active_icon, // url
        scaledSize: new google.maps.Size(30, 42.95),
      };

      var latLngStrip = latlngStr.split(",", 2);
      var latLng = new google.maps.LatLng(
        parseFloat(latLngStrip[0]),
        parseFloat(latLngStrip[1])
      );

      map.panTo(latLng);

      clearOverlays();
      var marker = new google.maps.Marker({
        map: map,
        position: latLng,
        icon: marker_active_icon_active,
      });
      markersArray.push(marker);
    }

    // fill in the UI elements with new position data
    function update_ui(
      label,
      address,
      latLngStr,
      building,
      place_id,
      provider_id = null
    ) {
      $("#map-location-input").autocomplete("close");
      $("#map-location-input-shortcode").autocomplete("close");
      $("#map-location-input").val(label);
      $("#map-location-input-shortcode").val(label);

      var hasGeocoded = false;

      if (latLngStr) {
        hasGeocoded = true;
        var latLngStrip = latLngStr.split(",", 2);
        var latLng = new google.maps.LatLng(
          parseFloat(latLngStrip[0]),
          parseFloat(latLngStrip[1])
        );
        coverageArray = [];
        for (var i = 0; i < polygons.length; i++) {
          if (google.maps.geometry.poly.containsLocation(latLng, polygons[i])) {
            coverageArray.push(polygons[i].id);
          }
        }
        if ($.inArray(latLngStr, internectMarkersArray) > -1) {
          if (provider_id == null) {
            coverageArray.push(static_provider);
          } else {
            coverageArray.push(provider_id);
          }
        }

        var uniqueProviders = unique(coverageArray);

        //Exclude other providers if Internect
        if ($.inArray(latLngStr, internectMarkersArray)) {
          if (provider_id == null) {
            uniqueProviders = [static_provider];
          } else {
            uniqueProviders = [provider_id];
          }
        }

        update_map(latLngStr);
        fetch_providers(uniqueProviders, latLngStr, building);
      } else {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ placeId: place_id }, function (results, status) {
          if (status === "OK") {
            if (results[0]) {
              hasGeocoded = true;
              //console.log(results[0].geometry.location.lat() +','+ results[0].geometry.location.lng());
              var latLngStr =
                results[0].geometry.location.lat() +
                "," +
                results[0].geometry.location.lng();
              var latLng = new google.maps.LatLng(
                parseFloat(results[0].geometry.location.lat()),
                parseFloat(results[0].geometry.location.lng())
              );
            }
            coverageArray = [];
            for (var i = 0; i < polygons.length; i++) {
              if (
                google.maps.geometry.poly.containsLocation(latLng, polygons[i])
              ) {
                coverageArray.push(polygons[i].id);
              }
            }
            if ($.inArray(latLngStr, internectMarkersArray) > -1) {
              //coverageArray.push(static_provider);
              if (provider_id == null) {
                coverageArray.push(static_provider);
              } else {
                coverageArray.push(provider_id);
              }
            }

            var uniqueProviders = unique(coverageArray);
            update_map(latLngStr);
            fetch_providers(uniqueProviders, latLngStr, building);
          }
        });
      }
    }

    $("#map-location-input").autocomplete({
      minLength: 0,
      source: function (request, response) {
        function split(val) {
          return val.split(/,\s*/);
        }
        function extractLast(term) {
          return split(term).pop();
        }
        var internectSource = $.ui.autocomplete.filter(
          internectSearchTags,
          extractLast(request.term.replace(/'/g, ""))
        );

        //var geocoder = new google.maps.Geocoder;

        var service = new google.maps.places.AutocompleteService();

        if ($.isEmptyObject(internectSource)) {
          service.getPlacePredictions(
            {
              input: request.term,
              bounds: allowedBounds,
              componentRestrictions: { country: "ZA" },
            },
            function (predictions, status) {
              //console.log(predictions);
              //for (var i = 0; i < predictions.length; i++) {}
              response(
                $.map(predictions, function (item) {
                  return {
                    label: item.description, // appears in dropdown box
                    value: item.description, // inserted into input element when selected
                    place_id: item.place_id,
                    geocode: null,
                    building: null,
                    provider_id: null,
                  };
                })
              );
            }
          );

          /*geocoder.geocode({'address': request.term, componentRestrictions: {country: 'ZA', administrativeArea: 'WC'} }, function(results, status) {
            response($.map(results, function(item) {
              return {
                label: item.formatted_address, // appears in dropdown box
                value: item.formatted_address, // inserted into input element when selected
                geocode: item.geometry.location.lat() +','+ item.geometry.location.lng(),                 // all geocode data: used in select callback event
                building: null
              }
            }));
          });*/
        } else {
          response(internectSource);
        }
      },
      select: function (event, ui) {
        event.preventDefault();
        $("#map-location-input").blur();
        //console.log(ui.item.label);
        update_ui(
          ui.item.label,
          ui.item.address,
          ui.item.geocode,
          ui.item.building,
          ui.item.place_id,
          ui.item.provider_id
        );
        //update_map( ui.item.geocode )
      },
    });
    /*.data("ui-autocomplete")._renderItem = function (ul, item) {
        var newText = String(item.label).replace(
                new RegExp(this.term, "gi"),
                "<span class='ui-state-highlight'>$&</span>");

        return $("<li></li>")
            .data("item.autocomplete", item)
            .append("<div>" + newText + "</div>")
            .appendTo(ul);
    };*/
    $("#map-location-input").autocomplete("option", "appendTo", "#map-search");

    var $windowWidth = $(window).width();
    if ($windowWidth < 769) {
      $("#map-location-input, #map-location-input-shortcode").on(
        "focus",
        function () {
          //$("html,body").animate({ scrollTop: $(this).offset().top - 60 }, 0);
        }
      );
    }

    //SEARCH SHORTCODE
    $("#map-location-input-shortcode").autocomplete({
      minLength: 0,
      source: function (request, response) {
        function split(val) {
          return val.split(/,\s*/);
        }
        function extractLast(term) {
          return split(term).pop();
        }
        var internectSource = $.ui.autocomplete.filter(
          internectSearchTags,
          extractLast(request.term.replace(/'/g, ""))
        );

        //var geocoder = new google.maps.Geocoder;
        var service = new google.maps.places.AutocompleteService();

        if ($.isEmptyObject(internectSource)) {
          service.getPlacePredictions(
            {
              input: request.term,
              bounds: allowedBounds,
              componentRestrictions: { country: "ZA" },
            },
            function (predictions, status) {
              //console.log(predictions);
              //for (var i = 0; i < predictions.length; i++) {}
              response(
                $.map(predictions, function (item) {
                  return {
                    label: item.description, // appears in dropdown box
                    value: item.description, // inserted into input element when selected
                    place_id: item.place_id,
                    geocode: null,
                    building: null,
                    provider_id: null,
                  };
                })
              );
            }
          );

          /* geocoder.geocode({'address': request.term, componentRestrictions: {country: 'ZA', administrativeArea: 'WC'} }, function(results, status) {
             response($.map(results, function(item) {
               return {
                 label: item.formatted_address, // appears in dropdown box
                 value: item.formatted_address, // inserted into input element when selected
                 geocode: item.geometry.location.lat() +','+ item.geometry.location.lng(),                 // all geocode data: used in select callback event
                 building: null
               }
             }));
           });*/
        } else {
          response(internectSource);
        }
      },
      select: function (event, ui) {
        event.preventDefault();
        $("#map-location-input-shortcode").blur();
        update_ui(
          ui.item.label,
          ui.item.address,
          ui.item.geocode,
          ui.item.building,
          ui.item.place_id,
          ui.item.provider_id
        );
        //update_map( ui.item.geocode )

        var shortcode_map_page = $("#map-location-input-shortcode").data("url");
        var currentURL = window.location.href.split("?")[0];
        var map_wrapper = $("#faircom-map-wrapper");
        if ($("#faircom-map-wrapper").length > 0) {
          $("html,body").animate({ scrollTop: map_wrapper.offset().top }, 0);
        } else {
          window.location.href = map_page + "#faircom-map-wrapper";
        }
      },
    });
    $("#map-location-input-shortcode").autocomplete(
      "option",
      "appendTo",
      ".map-search"
    );

    /*
    
        //SEARCH
        var input = document.getElementById('map-location-input');
        var autocomplete = new google.maps.places.Autocomplete(
            input, {placeIdOnly: true});
        autocomplete.bindTo('bounds', map);
        autocomplete.setComponentRestrictions(
                {'country': ['za']});
        var infowindow = new google.maps.InfoWindow({maxWidth: 280});
        var geocoder = new google.maps.Geocoder;
    
        autocomplete.addListener('place_changed', function() {
          infowindow.close();
          var place = autocomplete.getPlace();
          if (!place.place_id) {
            return;
          }
          geocoder.geocode({'placeId': place.place_id}, function(results, status) {
            if (status !== 'OK') {
              window.alert('Geocoder failed due to: ' + status);
              return;
            }
            //Workaround to remove link from infowindow
            var latlng = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            clearOverlays();
            var marker = new google.maps.Marker({
              map: map,
              position: latlng,
              icon: marker_icon
            });
            markersArray.push(marker);
            marker.addListener('click', function() {
              //infowindow.open(map, marker);
            });
            // end workaround
            map.setZoom(11);
            map.setCenter(results[0].geometry.location);
            marker.setVisible(true);
            coverageArray = [];
            for (var i = 0; i < polygons.length; i++) {
              if (google.maps.geometry.poly.containsLocation(latlng, polygons[i])) {
                coverageArray.push(polygons[i].id);
              }
            }
    
            if ( $.inArray(results[0].place_id, internectMarkersArray) > -1 ) {
                coverageArray.push(static_provider);
            }
    
            var openserve = openserveQuery(latlng);
            if(openserve == 'Working'){
              coverageArray.push(openserve_id);
            }
    
            var uniqueProviders = unique(coverageArray);
    
    
            var location_string = latlng.lat()+","+latlng.lng();
            fetch_providers(uniqueProviders, location_string);
          });
        });
    
        //SEARCH SHORTCODE
        $('#map-location-input-shortcode').on('change', function(){
          var shortcode_map_page = $(this).data('url');
          var currentURL=window.location.href.split('?')[0];
          var map_wrapper = $('#faircom-map-wrapper');
          if(shortcode_map_page !== currentURL){
            window.location.href = map_page + '#faircom-map-wrapper';
          }
          else{
            $('html,body').animate({scrollTop: map_wrapper.offset().top}, 0);
          }
        });
    
        var input2 = document.getElementById('map-location-input-shortcode');
        if(input2){
          var autocomplete2 = new google.maps.places.Autocomplete(
              input2, {placeIdOnly: true});
          autocomplete2.bindTo('bounds', map);
          autocomplete2.setComponentRestrictions(
                  {'country': ['za']});
    
          autocomplete2.addListener('place_changed', function() {
            infowindow.close();
            var place = autocomplete2.getPlace();
            if (!place.place_id) {
              return;
            }
            geocoder.geocode({'placeId': place.place_id}, function(results, status) {
              if (status !== 'OK') {
                window.alert('Geocoder failed due to: ' + status);
                return;
              }
              //Workaround to remove link from infowindow
              var latlng = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
              clearOverlays();
              $('#map-location-input').val(results[0].formatted_address);
              var marker = new google.maps.Marker({
                map: map,
                position: latlng,
                icon: marker_icon
              });
              markersArray.push(marker);
              marker.addListener('click', function() {
                //infowindow.open(map, marker);
              });
              // end workaround
              map.setZoom(11);
              map.setCenter(results[0].geometry.location);
              marker.setVisible(true);
              coverageArray = [];
              for (var i = 0; i < polygons.length; i++) {
                if (google.maps.geometry.poly.containsLocation(latlng, polygons[i])) {
                  coverageArray.push(polygons[i].id);
                }
              }
    
              if ( $.inArray(results[0].place_id, internectMarkersArray) > -1 ) {
                  coverageArray.push(static_provider);
              }
    
              var openserve = openserveQuery(latlng);
              if(openserve == 'Working'){
                coverageArray.push(openserve_id);
              }
    
              var uniqueProviders = unique(coverageArray);
    
    
              var location_string = latlng.lat()+","+latlng.lng();
              fetch_providers(uniqueProviders, location_string);
            });
          });
        }
        */

    // CLICK ADD MARKER
    map.addListener("click", function (e) {
      debugger;
      geocodeMarkerPanTo(e.latLng, map);
    });
  } //INITMAP

  if ($("#session_vars").length > 0 && $("#faircom-map-wrapper").length > 0) {
    var provider_session_var = $("#session_vars").data("provider");
    var location_session_var = $("#session_vars").data("location");
    var building_session_var = $("#session_vars").data("building");
    fetch_providers(
      provider_session_var,
      location_session_var,
      building_session_var
    );
  }

  function fetch_providers(providers, location, building) {
    $("#faircom-provider-results").css("display", "none");
    //$('#faircom-map-wrapper').css('justify-content', 'center');
    $("#faircom-map-wrapper .faircape-loader-big").removeClass("hide");
    var no_coverage_button_output =
      '<a class="button" href="' +
      form_url +
      "?no_coverage=true&location=" +
      location +
      '#form">' +
      no_coverage_button +
      "</a>";
    var no_coverage_message_output =
      '<a id="results_close" href="#">Clear search <span>×</span></a><div id="results_header">' +
      no_coverage_message +
      no_coverage_button_output +
      "</div>";

    $.post(
      ajax_object.ajaxurl,
      {
        security: $(document).find("#fibre_map_nonce_field").attr("value"),
        providers: providers,
        location: location,
        form_page: form_url,
        building: building,
        frogfoot_id: frogfoot_id,
        openserve_id: openserve_id,
        light_signup: $(document).find("#light_signup").attr("value"),
        action: "faircom_provider_results",
      },
      function (data) {
        $("#faircom-map-wrapper .faircape-loader-big").addClass("hide");
        if (data) {
          var jsonData = $.parseJSON(data);
          //console.log(jsonData);
          $("#map-modal .close-button").addClass("hide");
          if (jsonData["status"] == "planned") {
            var futureProviders =
              "Future providers: " + jsonData["future_providers"].join(" and ");
            var planned_coverage_button_output =
              '<a class="button" href="' +
              form_url +
              "?no_coverage=true&location=" +
              location +
              "&planned=true&future_providers=" +
              encodeURI(jsonData["future_providers"].join(" and ")) +
              '#form">' +
              planned_coverage_button +
              "</a>";
            var planned_coverage_message_output =
              '<a id="results_close" href="#">Clear search <span>×</span></a><div id="results_header">' +
              planned_coverage_message +
              "<p>" +
              futureProviders +
              "</p>" +
              planned_coverage_button_output +
              "</div>";

            $("#faircom-provider-results")
              .html(planned_coverage_message_output)
              .css("display", "block")
              .addClass("planned-coverage")
              .removeClass("has-coverage no-coverage");
            //$('#faircom-map-wrapper').css('justify-content', 'space-between');
            google.maps.event.trigger(map, "resize");
          } else if (jsonData["status"] == "live") {
            $("#faircom-provider-results")
              .html(jsonData["results"])
              .css("display", "block")
              .addClass("has-coverage")
              .removeClass("planned-coverage no-coverage");
            //$('#faircom-map-wrapper').css('justify-content', 'space-between');
            google.maps.event.trigger(map, "resize");
          } else {
            //console.log('none');
            $("#faircom-provider-results")
              .html(no_coverage_message_output)
              .css("display", "block")
              .removeClass("has-coverage planned-coverage")
              .addClass("no-coverage");
            //$('#faircom-map-wrapper').css('justify-content', 'space-between');
            google.maps.event.trigger(map, "resize");
          }
        }
      }
    );
  }

  $(document).on("click", "#results_close", function (e) {
    e.preventDefault();
    $("#map-modal .close-button").removeClass("hide");
    $("#faircom-provider-results").css("display", "none");
    //$('#faircom-map-wrapper').css('justify-content', 'center');
    $("#map-message-bottom").html("");
    $("#map-message-top").html("");
    $("#map-location-input").val("");
    clearOverlays();
    if (infowindow) {
      infowindow.close();
    }
  });

  /*
    $('.faircom-package a:not(.enquiry)').on('click', function(e){
      e.preventDefault();
      var map = $('#faircom-map-wrapper');
      var map_wrapper = $('#faircom-map-wrapper');
      var map_page = $(this).attr('href');
      if(map.length > 0){
        $('html,body').animate({scrollTop: map_wrapper.offset().top}, 0);
      }
      else{
        window.location.href = map_page;
      }
    });
  */

  function geocodeLatLng() {
    var geocoder = new google.maps.Geocoder();
    var input = $("#latlng").val();
    var latlngStr = input.split(",", 2);
    var latlng = {
      lat: parseFloat(latlngStr[0]),
      lng: parseFloat(latlngStr[1]),
    };
    geocoder.geocode({ location: latlng }, function (results, status) {
      if (status === "OK") {
        if (results[0]) {
          $("#location").text(results[0].formatted_address);
          $("#street_address").val(results[0].formatted_address);
        } else {
          window.alert("No results found");
        }
      } else {
        if ($(".is-admin").length > 0 || $(".no-location").length > 0) {
        } else {
          window.alert("Geocoder failed due to: " + status);
          window.location.href = map_page + "#faircom-map-wrapper";
          if (input == 0) {
            window.alert("Geocoder failed due to: " + status);
            window.location.href = map_page + "#faircom-map-wrapper";
          }
        }
      }
    });
  }
  if (
    $("#faircom-package-form-columns").length > 0 ||
    $("#faircom-package-form").length > 0 ||
    $("#faircom-package-form-no-coverage").length > 0
  ) {
    geocodeLatLng();
  }

  function geocodeMarkerPanTo(latLng, map) {
    var geocoder = new google.maps.Geocoder();
    //var infowindow = new google.maps.InfoWindow({maxWidth: 280});

    if (infowindow) {
      infowindow.close();
    }
    infowindow = new google.maps.InfoWindow({ maxWidth: 280 });

    geocoder.geocode({ location: latLng }, function (results, status) {
      if (status === "OK") {
        if (results[0]) {
          clearOverlays();
          var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: marker_icon,
          });
          markersArray.push(marker);
          var latlng = latLng;
          coverageArray = [];

          for (var i = 0; i < polygons.length; i++) {
            if (
              google.maps.geometry.poly.containsLocation(latLng, polygons[i])
            ) {
              coverageArray.push(polygons[i].id);
            }
          }

          var location_string = latlng.lat() + "," + latlng.lng();
          $("#map-location-input").val(results[0].formatted_address);

          var uniqueProviders = unique(coverageArray);

          fetch_providers(uniqueProviders, location_string);
          marker.addListener("click", function () {
            //infowindow.open(map, marker);
          });
          map.panTo(latLng);
          //setTimeout(function(){ infowindow.open(map, marker); }, 400);
        } else {
          window.alert("No results found");
        }
      } else {
        window.alert("Geocoder failed due to: " + status);
      }
    });
  }

  function clearOverlays() {
    for (var i = 0; i < markersArray.length; i++) {
      markersArray[i].setMap(null);
    }
  }

  function createPolygons(e) {
    if (e.feature.getGeometry().getType() == "Polygon") {
      var paths = [];
      for (var i = 0; i < e.feature.getGeometry().getArray().length; i++) {
        var path = [];
        paths.push(e.feature.getGeometry().getAt(i).getArray());
      }

      var polygon = new google.maps.Polygon({
        paths: paths,
        map: map,
        strokeColor: strokeColor,
        fillColor: fillColor,
        strokeOpacity: strokeOpacity,
        strokeWeight: strokeWeight,
        fillOpacity: fillOpacity,

        clickable: false,
        name: e.feature.getProperty("name"),
        id: e.feature.getProperty("id"),
        desc: e.feature.getProperty("desc"),
      });
      polygons.push(polygon);
    }
  }

  /*
    $('#faircom-provider-results .provider a.button').on('click', function(){
      gtag('event', 'click', {
        'event_category': 'Faircom map provider CTA clicked',
        'event_label': 'User clicked on provider results CTA'
      });
    });
  
    $('a.check-coverage.package-shortcode-cta').on('click', function(){
      gtag('event', 'click', {
        'event_category': 'Faircom Package CTA clicked',
        'event_label': 'User clicked on check-coverage CTA on packages slider'
      });
    });
    $('a.signup.package-shortcode-cta').on('click', function(){
      gtag('event', 'click', {
        'event_category': 'Faircom Package CTA clicked',
        'event_label': 'User clicked on sign-up CTA on packages slider'
      });
    });
  */

  var $small = $(".faircom-packages").data("small");
  var $medium = $(".faircom-packages").data("medium");
  var $large = $(".faircom-packages").data("large");

  $(".faircom-packages.is-slider").slick({
    infinite: true,
    slidesToShow: $large,
    adaptiveHeight: true,
    //centerMode:true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: $large,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: $medium,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: $small,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  });

  var options = $("#building_selector option");
  var arr = options
    .map(function (_, o) {
      return { t: $(o).text(), v: o.value };
    })
    .get();
  arr.sort(function (o1, o2) {
    return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0;
  });
  options.each(function (i, o) {
    o.value = arr[i].v;
    $(o).text(arr[i].t);
  });
});
